import { render, staticRenderFns } from "./IntangibleCate.vue?vue&type=template&id=3ca9e52b&"
import script from "./IntangibleCate.vue?vue&type=script&lang=js&"
export * from "./IntangibleCate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports